import React from 'react';
import { createPortal } from 'react-dom'
import Modal from '../../../Modal';

import style from "../Toxics/components/ModalPortal/style/modalportal.scss";

const ModalPortal = (props) => {
    const { isOpen, onClose, children } = props;

    const container = document.getElementById("report_modal");

    return createPortal(isOpen ? (
        <div className={style.modalWrapper}>
            <Modal
                classes={{
                    modal: style.reportModal,
                    modalBackground: style.reportModalBackground
                }}
                closeModal={onClose}
            >
                {children}
            </Modal>
        </div>
    ) : null, container);
}

export default ModalPortal;
